var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Elv24 = function Elv24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.656 3.5H3.344A.344.344 0 0 0 3 3.844V20.01c0 .19.154.343.344.343h17.312c.19 0 .344-.154.344-.343V3.844a.344.344 0 0 0-.344-.344z",
    fill: "#fff",
    stroke: "#01509B",
    strokeWidth: ".5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.493 18.173h-6.94c-.57 0-.955-.57-.955-.977 0-.378.01-10.373 0-10.76-.01-.387.665-.987 1.118-.987.453.01 6.767 0 6.767 0v5.04H14.8V8.1s-.242-.009-.55 0c-.154.01-.414.165-.414.417-.01.522 0 6.56 0 6.715 0 .145.096.338.414.348.318.02.56 0 .56 0v-2.584h3.682v5.177z",
    fill: "#E11A1D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.412 8.08s-.279-.018-.53-.008c-.26.009-.481.261-.481.416v2.002h1.011V8.08zM6.29 5.45c.762.01 6.313 0 6.313 0v7.546L8.4 12.987v2.216c0 .038.106.367.482.387h.52v-1.868h3.21l-.01 4.451H6.26s-.955-.155-1.041-1.083c.01-.349 0-10.5 0-10.673 0-.164.366-.968 1.07-.968z",
    fill: "#00509B"
  }));
};

Elv24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Elv32 = function Elv32(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    x: ".5",
    y: ".5",
    width: "31",
    height: "23",
    rx: "3.5",
    fill: "#fff",
    stroke: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.493 18.173h-6.94c-.57 0-.955-.57-.955-.977 0-.378.01-10.373 0-10.76-.01-.387.665-.987 1.118-.987.453.01 6.767 0 6.767 0v5.04H18.8V8.1s-.241-.009-.55 0c-.154.01-.414.165-.414.417-.01.522 0 6.56 0 6.715 0 .145.096.338.414.348.318.02.56 0 .56 0v-2.584h3.682v5.177z",
    fill: "#E11A1D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.413 8.08s-.28-.018-.53-.008c-.26.009-.482.261-.482.416v2.002h1.012V8.08zM10.29 5.45c.762.01 6.313 0 6.313 0v7.546l-4.202-.009v2.216c0 .038.106.367.482.387h.52v-1.868h3.21l-.01 4.451h-6.342s-.955-.155-1.041-1.083c.01-.349 0-10.5 0-10.673 0-.164.367-.968 1.07-.968z",
    fill: "#00509B"
  }));
};

Elv32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Elv24,
  '32': Elv32
};
export var Elv = function Elv(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Elv' icon. Please use one of the available sizes: '24', '32'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};